"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTextFragment = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.ProductTextFragment = (0, graphql_tag_1.default) `
  fragment ProductPropertyTextIssueFragment on ProductPropertyTextIssueType {
    errorReport
    issues {
      productKey
      propertyName
      params {
        propertyValue
        languages
      }
      type
    }
  }
`;
//# sourceMappingURL=queries.js.map